import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { getImageUrl } from '../../services/api';
import type { CardioProgressSession } from './types';

interface CardioHistoryProps {
  cardioProgress: CardioProgressSession[];
}

const CardioHistory: React.FC<CardioHistoryProps> = ({ cardioProgress }) => {
  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 1.5, fontWeight: 600 }}>
        История на Кардио Сесии
      </Typography>
      {cardioProgress.map((session) => (
        <Card key={session.sessionId} sx={{ mb: 1.5 }}>
          <CardContent sx={{ p: '12px !important', '&:last-child': { pb: '12px !important' } }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                {session.exerciseName}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {new Date(session.date).toLocaleDateString('bg-BG')}
              </Typography>
            </Box>
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 12px' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="caption" color="textSecondary">Време</Typography>
                <Typography variant="caption" sx={{ fontWeight: 600 }}>{session.durationMinutes} мин</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="caption" color="textSecondary">Калории</Typography>
                <Typography variant="caption" sx={{ fontWeight: 600 }}>{session.caloriesBurned || '-'}</Typography>
              </Box>
              {session.distance && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="caption" color="textSecondary">Дистанция</Typography>
                  <Typography variant="caption" sx={{ fontWeight: 600 }}>{session.distance} {session.distanceUnit}</Typography>
                </Box>
              )}
              {session.avgSpeed && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="caption" color="textSecondary">Скорост</Typography>
                  <Typography variant="caption" sx={{ fontWeight: 600 }}>{session.avgSpeed}</Typography>
                </Box>
              )}
              {session.heartRateAvg && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="caption" color="textSecondary">Ср. Пулс</Typography>
                  <Typography variant="caption" sx={{ fontWeight: 600 }}>{session.heartRateAvg} bpm</Typography>
                </Box>
              )}
              {session.heartRatePeak && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="caption" color="textSecondary">Пик Пулс</Typography>
                  <Typography variant="caption" sx={{ fontWeight: 600 }}>{session.heartRatePeak} bpm</Typography>
                </Box>
              )}
            </Box>
            {session.resultImage && (
              <Box sx={{ mt: 1.5, textAlign: 'center' }}>
                <img
                  src={getImageUrl(session.resultImage)}
                  alt={`${session.exerciseName} - ${new Date(session.date).toLocaleDateString('bg-BG')}`}
                  style={{ maxWidth: '100%', maxHeight: 300, borderRadius: 8, objectFit: 'contain' }}
                />
              </Box>
            )}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default CardioHistory;
